import IMManager from '../im/IMManager'
import {isnull, isNum, localClear, localClearExcept, localGet, localSave, Toast} from '../utils/tools'
import global from '../config/global'
import router from "../router";
import BlockedUserUtils from "../utils/BlackUtils";
import {resolvePush} from "../push/SSEPushReceiver";
import EventBusConstant from "../push/const/EventBusConstant";
import accountApi from '../api/account-api'

export default class AppSDK {
  static pageV = null

  static toast(msg, type) {
    let extra = {
      msg: msg,
      type: type
    }
    this.callNative('toast', extra)
  }

  static purchaseInApp(product) {
    console.log('PurchaseInApp', JSON.stringify(product))
    this.callNative('purchaseInApp', product)
  }

  static async loadAppDevice() {
    let result = await prompt('requestLocalDeviceId');
    console.log('appDevice:' + result)
    if (isnull(result))
      return
    if (typeof result === 'string') {
      global.saveAppInfo(result)
      result = JSON.parse(result)
    } else {
      global.saveAppInfo(JSON.stringify(result))
    }
    global.setAppName(result.appName)
    global.setAppVersionName(result.versionName)
    global.setAppVersion(result.webVersion)
    global.setAppDeviceId(result.deviceId)
    global.setAppChannel(result.channel)
    global.setServiceAddr(result.service)
    global.setPrivacyAddr(result.privacy)
    global.setSecret(result.s)
    global.setAppDeviceName(result.deviceName)
    return result;
  }

  static async loadAppCache() {
    let result = await prompt('requestAppCache')
    return result;
  }

  static toAppStore() {
    this.callNative('toAppStore', '')
  }

  static ShowOuterPayPage(payAddr) {
    this.callNative('ShowOuterPayPage', payAddr)
  }

  static clearAppCache() {
    this.callNative('clearAppCache', '')
  }

  static hidePreLoader() {
    localSave(global.key.HIDE_PRE_LOADER, true)
    this.callNative('hidePreLoader', '')
  }

  static trackRecharge(productId,productUSD, coefficient) {
    this.callNative('trackRecharge', {
      productId: productId,
      productUSD: productUSD,
      coefficient:coefficient
    })
  }

  static track(name, data = '', common = '') {
    if (!isnull(data) && typeof data == 'object')
      data = JSON.stringify(data)
    if (!isnull(common) && typeof common == 'object')
      common = JSON.stringify(common)
    // let params = JSON.stringify({
    //   name: name,
    //   data: data,
    //   common: common,
    // })
    this.callNative('trackEvent', name)
  }

  static notifyGoBack(canGoBack) {
    this.callNative('notifyGoBack', canGoBack)
  }

  static notifySVIPShowed() {
    this.notifySave2AppStorage(global.getUserDisplay() + '_chatFeeShowed', true)
  }

  static notifyVCRGuideShowed() {
    this.notifySave2AppStorage(global.getUserDisplay() + '_vcrGuideShowed', true)
  }

  static notifySaveSearch(history) {
    this.callNative('saveSearch', history)
  }

  static async loadHistory() {
    let historyData = await prompt('loadSearch')
    if (isnull(historyData)) {
      return ''
    }
    return historyData
  }

  static notifySave2AppStorage(key, data) {
    let params = {
      key: key,
      data: data
    }
    this.callNative('save2App', params)
  }

  static async loadFromAppStorage(key) {
    let historyData = await prompt(key)
    if (isnull(historyData)) {
      return ''
    }
    return historyData
  }

  static async requestLocalPermission() {
    let result = await prompt('requestLocalPermission')
    if (isNum(result)) {
      result = 0 !== parseInt(result)
    }
    if (typeof result == 'string')
      result = result === 'true'
    return result;
  }

  static async callNative(fun, params) {
    await window.webkit.messageHandlers.appSdk.postMessage({
      body: {
        fun: fun,
        params: params
      }
    })
  }

  bindAppMethod(router) {
    window.closeC = () => {
      AppSDK.notifyGoBack(true)
    }

    window.exitRoom = () => {
      router.goBack()
    }

    window.unexpectedExit = () => {
      router.goBack()
    }

    window.keyboardHeight = (height) => {
      if (height > 0)
        document.getElementsByClassName('Router')[0].style.height = height + 'px'
      else
        document.getElementsByClassName('Router')[0].style.height = '100%'
    }

    window.logout = () => {
      AppSDK.logoutFromApp()
    }

    window.push = (pushRSP) => {
      if (isnull(pushRSP)) {
        return
      }
      console.log(pushRSP)
      if (typeof pushRSP === 'string') {
        pushRSP = JSON.parse(pushRSP)
      }
      resolvePush(pushRSP, AppSDK.pageV)
    }

    /**
     * [{k:'xxxx_show_chat_hint',v:true/fase},{k:'xxxx_show_vcr_guide',v:true/fase}]
     * @param showInfo
     */
    window.bindShowed = (showInfo) => {
      if (typeof showInfo === 'string') {
        showInfo = JSON.parse(showInfo)
      }
      if (!isnull(showInfo))
        showInfo.forEach(item => {
          localSave(item.k, item.v)
        })
      // localSave(displayAcc + '_show_chat_hint', showInfo.chatFeeShowed)
      // localSave(displayAcc + '_show_vcr_guide', showInfo.vcrGuideShowed)
    }

    window.hideVideo = () => {
      global.application.$EventBus.$emit(EventBusConstant.EVENT_HIDE_VIDEO)
    }

    window.bindAppInfo = (appInfo) => {
      if (typeof appInfo === 'string') {
        appInfo = JSON.parse(appInfo)
      }
      if (!isnull(appInfo)) {
        global.setAppName(appInfo.appName)
        global.setAppVersionName(appInfo.versionName)
        global.setAppVersion(appInfo.webVersion)
        global.setAppDeviceId(appInfo.device)
        global.setAppChannel(appInfo.channel)
        global.setServiceAddr(appInfo.service)
        global.setPrivacyAddr(appInfo.privacy)
      }
    }

    /**
     * {
        "channelId": 0,
        "receipt": "string",
        "afId": "string",
        "hostId": 0,
        "fromZhuanpan": true
}
     */
    window.checkInAppPay = (inAppPay) => {
      if (typeof inAppPay === 'string') {
        inAppPay = JSON.parse(inAppPay)
      }
      if (!isnull(inAppPay)) {
        if (isnull(inAppPay.hostId))
          inAppPay.hostId = 0
        accountApi.checkInAppPay(inAppPay, (data, page) => {
          AppSDK.trackRecharge(data.productId,data.priceUSD,data.coefficient)
          global.addCoins(data.leftDiamond)
          global.application.$EventBus.$emit(EventBusConstant.EVENT_IAP_PAY_SUCCESS, data.productId)
        }, (code, msg, page) => {
        }, global.application)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/api/aapp.js